const ClaimKeys = {
  AllowedItem:"AllowedItem",
  CanViewPreAdmissionPages: "CanViewPreAdmissionPages",
  CanViewAllPages: "CanViewAllPages",
};

export default ClaimKeys;
